import { GithubOutlined, HomeOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
import ChatBot from '../bot/chat';

const Footer: React.FC = () => {
  return (
    <>
      <DefaultFooter
        copyright="2022025 Powered by Hai Phong University"
        links={[
          {
            key: 'home',
            title: <HomeOutlined />,
            href: 'https://dhhp.edu.vn',
            blankTarget: true,
          },
          {
            key: 'portal',
            title: 'Trang chủ',
            href: 'https://dhhp.edu.vn',
            blankTarget: true,
          }
        ]}
      />
      <ChatBot />
    </>
  );
};

export default Footer;
